const FALLBACK_PATH = "/";

export function toSafeInternalPath(value: string | undefined | null): string {
  if (!value) return FALLBACK_PATH;

  const normalised = value.replace(/\\/g, "/");
  if (!normalised.startsWith("/") || normalised.startsWith("//")) {
    return FALLBACK_PATH;
  }

  let resolved: URL;
  try {
    resolved = new URL(normalised, window.location.origin);
  } catch {
    return FALLBACK_PATH;
  }

  if (resolved.origin !== window.location.origin) return FALLBACK_PATH;

  return `${resolved.pathname}${resolved.search}${resolved.hash}`;
}
